import { render } from "./Biometric.vue?vue&type=template&id=547caf5f"
import script from "./Biometric.vue?vue&type=script&lang=js"
export * from "./Biometric.vue?vue&type=script&lang=js"

import exportComponent from "/builds/off-group-apps/personal-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__